function compare(a, b) {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
}

export const COLOR_TYPES = {
  RED: "RED",
  GREEN: "GREEN",
  BLUE: "BLUE",
  YELLOW: "YELLOW",
};

const getOnlyTwoDominateColors = (result) => {
  const denominator = (result.R + result.B + result.G + result.Y) / 2;
  const yPercentage = result.Y / denominator;
  const rPercentage = result.R / denominator;
  const gPercentage = result.G / denominator;
  const bPercentage = result.B / denominator;
  const dominateColors = [
    {
      colorType: COLOR_TYPES.YELLOW,
      value: yPercentage,
    },
    {
      colorType: COLOR_TYPES.RED,
      value: rPercentage,
    },
    {
      colorType: COLOR_TYPES.GREEN,
      value: gPercentage,
    },
    {
      colorType: COLOR_TYPES.BLUE,
      value: bPercentage,
    },
  ];
  return dominateColors.sort(compare).reverse().splice(0, 2);
};

export const getOnlyOneDominateColor = (result) => {
  const denominator = (result.R + result.B + result.G + result.Y) / 2;
  const yPercentage = result.Y / denominator;
  const rPercentage = result.R / denominator;
  const gPercentage = result.G / denominator;
  const bPercentage = result.B / denominator;
  const dominateColors = [
    {
      colorType: COLOR_TYPES.YELLOW,
      value: yPercentage,
    },
    {
      colorType: COLOR_TYPES.RED,
      value: rPercentage,
    },
    {
      colorType: COLOR_TYPES.GREEN,
      value: gPercentage,
    },
    {
      colorType: COLOR_TYPES.BLUE,
      value: bPercentage,
    },
  ];
  return dominateColors.sort(compare).reverse().splice(0, 1);
};

export default getOnlyTwoDominateColors;
